import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
export const PrivateRoute = ({ children, isSupervisorRistricted, ...rest }) => {
  const { isAuthenticated } = useSelector((state) => state.user.auth);
  const { isApprover } = useSelector((state) => state.user.auth.user);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated && isSupervisorRistricted && isApprover ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
